module.exports = __webpack_public_path__ + "static/img/thank-you.6cd82ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/thank-you.png
// module id = 6akV
// module chunks = 36